module.exports = __webpack_public_path__ + "img/superb-disabled.93d337a4.svg";